<template>
    <button
        type="button"
        :class="['o-path-steps-item-otg', activeClass]"
        @click="onClick"
    >
        <div class="step-indicator">
            {{ step.stepIndicator }}
        </div>
        <OStepText
            :step="step"
            class="step-text"
        />
    </button>
</template>

<script>
import { computed } from '@vue/composition-api';

import OStepText from '../../unique-organisms/o-step-text/o-step-text';

export default {
    name: 'OPathStepsItemOtg',
    components: {
        OStepText
    },
    props: {
        step: {
            type: Object,
            required: true
        }
    },
    setup(props, { emit }) {
        const activeClass = computed(() => props.step.isActive ? 'path-steps-item-otg-active' : null);

        function onClick() {
            emit('onClick', props.step.idx);
        }

        return {
            onClick,
            activeClass
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />